export default __webpack_public_path__ + "static/bgImageMd-b60f8fb93e4f55b4b6b6043679f3297d.png";